module.exports = __webpack_public_path__ + "media/svg-new/terra-ccf08662.svg";